
export default function CompanyIntro() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { number: '15+', label: '활동 연차' },
    { number: '1500+', label: '누적 공연' },
    { number: '3', label: '전국 지점' },
  ];

  const services = [
    { title: '공연', desc: '기업·공공·교육' },
    { title: '체험', desc: '키즈·가족·단체·학교' },
    { title: '영상', desc: '홍보·기념·교육·웨딩' },
  ];

  return (
    <section id="company" className="py-32 lg:py-40 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">

        {/* Section Title */}
        <div className="mb-20 lg:mb-28">
          <p className="text-xs font-medium tracking-widest uppercase text-primary mb-4">About</p>
          <h2 className="text-3xl lg:text-5xl font-light text-black leading-tight tracking-tight">
            모래 한 알에<br />
            이야기를 담습니다
          </h2>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 mb-20 lg:mb-28">
          <div>
            <p className="text-sm lg:text-base text-textGray font-light leading-relaxed">
              모래요정 K-star 샌드아트는 대한민국 샌드아트 자격증 등록업체로서,
              전문성과 창의성을 바탕으로 고객의 특별한 순간을 더욱 감동적으로 만들어드립니다.
            </p>
          </div>
          <div>
            <p className="text-sm lg:text-base text-textGray font-light leading-relaxed">
              기업행사, 축제, 웨딩부터 교육 체험까지,
              맞춤형 스토리와 섬세한 연출로 잊지 못할 경험을 선사합니다.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-8 py-14 border-y border-lineGray mb-20 lg:mb-28">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-4xl lg:text-6xl font-light text-black mb-2 tracking-tight">{stat.number}</p>
              <p className="text-xs font-medium tracking-widest uppercase text-textGray">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Services Overview */}
        <div className="grid md:grid-cols-3 gap-px bg-lineGray">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white px-10 py-12 text-center hover:bg-warmWhite transition-colors duration-300"
            >
              <h3 className="text-xl lg:text-2xl font-light text-black mb-2">{service.title}</h3>
              <p className="text-sm text-textGray font-light tracking-wide">{service.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-20 lg:mt-28">
          <p className="text-sm text-textGray font-light mb-6 tracking-wide">
            행사 유형과 날짜만 알려주시면 최적의 제안을 드립니다
          </p>
          <button
            onClick={() => scrollToSection('contact')}
            className="px-10 py-4 bg-black text-white text-xs font-medium tracking-wider uppercase hover:bg-black/80 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            상담 문의
          </button>
        </div>

      </div>
    </section>
  );
}
